export default __webpack_public_path__ + "static/media/icon_avla.7dba1a43.svg";